import Rest from '../rest'

/******************************************************************************
 *  Tags
 *****************************************************************************/

/**
 * @type {Tag}
 */
export default class Deal extends Rest {

    constructor () {
        super('/tags')
    }

    /**
     * Retorna as tags desejadas, formatadas como opções para um select
     * 
     * @param {String} type
     */
    getTagOptions(type) {
        return this.getAll(type, {}).then(response => {
            let tagOptions = Object.values(response.data).map(item => {
                return { id: item.id, label: item.tag, value: item.tag, type: item.tagable_type == 'Customer_Main' ? 'Cliente' : 'Negócio'}
            })
            response.data = [...tagOptions]

            return response
        })
    }
}